<oui-multi-select-dropdown
  [options]="optionsWithAll()"
  [value]="value"
  (valueChange)="onDropdownUpdate($event)"
/>
